import React from 'react';
import { FormattedMessage } from 'react-intl';

export const WEBINAR_ID = {
    id: 'oe.input.webinarID',
    description: 'Input label',
    defaultMessage: 'Webinar ID'
};

export const PRESENTERS = {
    id: 'oe.input.presenters',
    description: 'Input label',
    defaultMessage: 'Presenters'
};

export const HOSTS = {
    id: 'oe.input.hosts',
    description: 'Input label',
    defaultMessage: 'Hosts'
};

export const SUPPORT = {
    id: 'oe.input.support',
    description: 'Input label',
    defaultMessage: 'Support'
};

export const CREATE_PANELIST_LINK_TEXT = <FormattedMessage
    id="oe.panelistLink.createTitle"
    defaultMessage="Create Panelist Link"
/>;

export const ADD_DETAILS_MANUALLY_TEXT = <FormattedMessage
    id="oe.panelistLink.addDetailsManually"
    defaultMessage="Add Details Manually"
/>;

export const alertPanelistLinkConnectionMessage = <FormattedMessage
    id='oe.connections.alerts.deleteThisPanelistLinkConnection'
    description='Alert message second part'
    defaultMessage='delete this Zoom Panelist connection'
/>;

export const panelistLinkWarningMessage = <FormattedMessage
    id='oe.connections.alerts.deleteBothThePanelistLinkAndTheConnectionOrDeleteOnlyTheConnectionWillBeDeletedAndUnassigned'
    description='Warning message'
    defaultMessage='You can choose to permanently delete the Connection and remove the panelist from the Zoom Webinar, or to delete only the Connection and unassign it from all attendees.'
/>;

export const cancelCreatePanelistLinkMessage = <FormattedMessage
    id='oe.meeting.cancelCreatingPanelistLink'
    defaultMessage='cancel creating this Panelist Link connection'
    description='Label text'
/>;

export const panelistDeletionToastMessage = 'Panelist successfully removed';